<div class="cont-plans mt-3 mt-md-5">
  <div class="py-5 pb-5">
    <div class="row pb-4 m-0">
      <div class="col-12">
        <div class="container">
          <div class="text-center pb-3">
            <h2><span class="title-blue font-size-32"> Nuestros Planes de Asistencia de Viaje</span></h2>
          </div>
          <p class="text-info-plans">
            Contamos con una variedad de planes hechos especialmente para ti. Podrás encontrar el plan perfecto si eres estudiante, adulto mayor, empresario, si planeas un viaje de corta o larga estadía. <b>¡Estamos hechos para todos!</b>
          </p>
        </div>
      </div>

      <div class="col-12 cont-carousel" *ngIf="this.plans.length > 0">
        <div class="carousel">
          <p-carousel
            id="info-plans"
            [value]="plans"
            [numVisible]="4"
            [numScroll]="1"
            [circular]="true"
            [responsiveOptions]="responsiveOptions"
            [showNavigators]="true"
            [autoplayInterval]="5000"
            [showIndicators]="false"
          >
            <ng-template let-service pTemplate="item">
              <div class="col-md-12 justify-content-center d-flex mb-4 mt-1 card-plans-cont">
                <div class="card-plans position-relative">
                  <div class="header-image-container position-relative">
                    <img class="img-card w-100" [src]="service.ImageUrl" alt="Banner plan" loading="lazy" />
                    <div *ngIf="service.index == 0" class="recommended-ribbon d-flex align-items-center justify-content-center">
                      <img
                        src="https://res.cloudinary.com/pervolare-org/image/upload/v1773709646/TAS/home/Vector_fi4gid.svg"
                        alt="fire icon"
                        class="me-1"
                      />
                      <span>Recomendado</span>
                    </div>
                    <div class="title-overlay">
                      <h2 class="text-white m-0"><b>{{ service.Name }}</b></h2>
                    </div>
                  </div>

                  <div class="content-card-plans px-4 py-3 text-start d-flex flex-column flex-grow-1">
                    <p class="m-0 coverage-label">Cobertura de</p>
                    <div class="d-flex align-items-baseline coverage-amount-container mb-3 pb-3 border-bottom">
                      <h3 class="m-0 coverage-amount" [ngClass]="'text-primary-dark'">
                        ${{ service.Coverage | number }}
                      </h3>
                      <span class="ms-2 coverage-currency">EUR/USD</span>
                    </div>
                    
                    <div class="benefits-list mb-3">
                      <div *ngFor="let data of service.PlanSummary.slice(0, 4)" class="d-flex align-items-start mb-2 benefit-item">
                        <img
                          src="https://res.cloudinary.com/pervolare-org/image/upload/v1773709646/TAS/home/bxs_up-arrow_2_owtr8v.svg"
                          class="benefit-icon mt-1 me-2"
                          alt="icon"
                          loading="lazy"
                        />
                        <span class="benefit-text">{{ data.Benfit }}</span>
                      </div>
                    </div>

                    <p class="ideal-text mb-4">
                      Ideal para: <b>{{service.FeePlan}}</b>
                    </p>

                    <div class="btn-seemore mt-auto w-100 text-center">
                      <button
                        class="btn-dark-blue w-100"
                        [routerLink]="['/planes', service.Name?.toLowerCase()?.trim()?.replace(' ', '-')]"
                      >
                        Saber más
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-carousel>
        </div>
      </div>
    </div>
  </div>
</div>
